import { checkChatResponse } from '../../apiErrors'
import { parseSchema, QuestionnaireDataError } from './model'
import { Answers, QuestionnaireSchema } from './types'

export async function getQuestionnaire(
  token: string,
  chatServer: string,
): Promise<QuestionnaireSchema> {
  const response = await fetch(`${chatServer}/questionnaire/questions`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  await checkChatResponse(response)
  return parseSchema(await response.json())
}

export async function autofillQuestionnaire(
  token: string,
  chatServer: string,
  text: string,
): Promise<string> {
  const response = await fetch(`${chatServer}/questionnaire/autofill`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ text }),
  })
  await checkChatResponse(response)
  const body = await response.json()
  if (typeof body?.filledQuestionnaire !== 'string')
    throw new QuestionnaireDataError('autofill')
  return body.filledQuestionnaire
}

export async function submitQuestionnaire(
  token: string,
  chatServer: string,
  answers: Answers,
): Promise<void> {
  const response = await fetch(`${chatServer}/questionnaire/answers`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ answers }),
  })
  await checkChatResponse(response)
  const body = await response.json()
  if (body?.status !== 'success')
    throw new Error('Questionnaire submission was not confirmed')
}
